import React from 'react';
import { HeaderSlot } from '../templates/HeaderSlot';
import { FooterSlot } from '../templates/FooterSlot';
import { Toaster } from '../ui/toaster';

interface PublicLayoutProps {
  children: React.ReactNode;
  // Optionnel: forcer un footer spécifique (ex: pour admin)
  forceFooter?: React.ComponentType;
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children, forceFooter: FooterComponent }) => {
  const renderFooter = () => {
    if (FooterComponent) return <FooterComponent />;
    return <FooterSlot />;
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Slot d'en-tête modulable par page/domaine (fallback PublicHeader) */}
      <HeaderSlot />
      <main className="flex-grow">{children}</main>
      {/* Slot de pied de page modulable par domaine (fallback PublicFooter) */}
      {renderFooter()}
      <Toaster />
    </div>
  );
};